// extracted by mini-css-extract-plugin
module.exports = {"root":"_2aWSd","buyer-note-divider":"_1AK3G","buyerNoteDivider":"_1AK3G","divider":"_31KDe","section":"_2Evlx","totals":"_1CvzG"};